import * as t from 'io-ts';

import {RConversationIdRef, RMessageUidRef} from '../../../models/api/apiTypes';
import {RCellsContext} from '../cells/context/cellsContext';
import {PanelTypesEnum, RAppPanelId, RMessagePanelId, RPanelStateBase} from '../panelStateBase';

/*
 * Runtime type.
 */

export const RMessageViewerPanelStateDirty = t.intersection([
  RPanelStateBase,
  t.type({
    id: RMessagePanelId,
    type: t.literal(PanelTypesEnum.MESSAGE),
    popupAppPanelId: RAppPanelId,
    cellsContext: t.union([t.undefined, RCellsContext]),
    messageUid: RMessageUidRef,
    conversationId: RConversationIdRef,
    initialHeight: t.union([t.undefined, t.number]),
  }),
]);

/*
 * Types.
 */

export interface MessageViewerPanelState extends Readonly<t.TypeOf<typeof RMessageViewerPanelStateDirty>> {}
export const RMessageViewerPanelState = t.clean<MessageViewerPanelState>(
  RMessageViewerPanelStateDirty as any,
);
